<template>
  <v-app  light id="inspire">
    <sidebar :drawer="drawer"></sidebar>
    <v-toolbar color="primary"   fixed app>
      <v-toolbar-side-icon @click.stop="handleDrawerToggle"></v-toolbar-side-icon>

      <v-toolbar-title><I>Industech</I></v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn icon @click="handleFullScreen()">
        <v-icon>fullscreen</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content>
      <router-view/>
    </v-content>
<!-- 
    <v-footer color="indigo" app>
      <span class="white--text">&copy; 2017</span>
    </v-footer> -->


  </v-app>
</template>

<style>
</style>
<script>
import sidebar from "../components/sidebar.vue";
import AppEvents from "../event";

export default {
  created() {
    AppEvents.forEach(item => {
      this.$on(item.name, item.callback);
    });
    window.getApp = this;
  },
  data: () => ({
    drawer: false
  }),
  components: {
    sidebar
  },
  props: {
    source: String
  },
  methods: {
    handleDrawerToggle() {
      window.getApp.$emit("APP_DRAWER_TOGGLED");
    },
    handleFullScreen() {
      let doc = window.document;
      let docEl = doc.documentElement;

      let requestFullScreen =
        docEl.requestFullscreen ||
        docEl.mozRequestFullScreen ||
        docEl.webkitRequestFullScreen ||
        docEl.msRequestFullscreen;
      let cancelFullScreen =
        doc.exitFullscreen ||
        doc.mozCancelFullScreen ||
        doc.webkitExitFullscreen ||
        doc.msExitFullscreen;

      if (
        !doc.fullscreenElement &&
        !doc.mozFullScreenElement &&
        !doc.webkitFullscreenElement &&
        !doc.msFullscreenElement
      ) {
        requestFullScreen.call(docEl);
      } else {
        cancelFullScreen.call(doc);
      }
    }
  }
};
</script> 